import React, { useEffect, useState } from 'react'
import { message } from 'antd'
import { useHistory, useParams } from 'react-router-dom'
import SewingHandoverPrintPage from './SewingHandoverPrintPage'
import { getSewingHandoverPrintData, printSewingHandover } from '../../../../services/api/3dApi'
import downloadFileFromData from '../../../../helpers/downloadFileFromData'
import { PRINTING_BODY_CLASS, buildSlipCsv, getInitialPrintInfo } from '../../helpers/print'
import '../../styles/print.scss'

const HISTORY_PATH = '/sewing-handover/history'

// @page là rule toàn cục, không scope được theo class -> chỉ gắn khi đang ở màn này.
const PAGE_STYLE = '@page { size: A4 portrait; margin: 12mm 12mm; }'

const SewingHandoverPrintContainer = () => {
    const history = useHistory()
    const { id } = useParams()

    const [loading, setLoading] = useState(false)
    const [printing, setPrinting] = useState(false)
    const [handover, setHandover] = useState(null)
    const [printInfo, setPrintInfo] = useState(getInitialPrintInfo(null))
    // Tăng sau khi API in trả về; effect gọi window.print() khi phiếu đã render số lần in mới.
    const [printRequest, setPrintRequest] = useState(0)

    useEffect(() => {
        const style = document.createElement('style')
        style.setAttribute('data-sewing-handover-print', '')
        style.innerHTML = PAGE_STYLE
        document.head.appendChild(style)
        document.body.classList.add(PRINTING_BODY_CLASS)

        return () => {
            document.head.removeChild(style)
            document.body.classList.remove(PRINTING_BODY_CLASS)
        }
    }, [])

    useEffect(() => {
        let cancelled = false

        const _fetchHandover = async () => {
            setLoading(true)
            setHandover(null)
            try {
                const { data: res } = await getSewingHandoverPrintData(id)
                if (cancelled) return
                const { success, data, error } = res || {}
                if (!success) throw new Error(error)
                setHandover(data)
                setPrintInfo(getInitialPrintInfo(data))
            } catch (e) {
                if (cancelled) return
                message.error(e.message)
            } finally {
                if (!cancelled) setLoading(false)
            }
        }

        _fetchHandover()

        return () => { cancelled = true }
    }, [id])

    useEffect(() => {
        if (printRequest > 0) window.print()
    }, [printRequest])

    const _onChangePrintInfo = (key, value) => setPrintInfo(prev => ({ ...prev, [key]: value }))

    const _onPrint = async () => {
        if (!handover || printing) return

        setPrinting(true)
        try {
            const { data: res } = await printSewingHandover(id, printInfo)
            const { success, data, error } = res || {}
            if (!success) throw new Error(error)
            setHandover(prev => ({ ...prev, ...data }))
            setPrintInfo(getInitialPrintInfo({ ...handover, ...data }))
            setPrintRequest(count => count + 1)
        } catch (e) {
            message.error(e.message)
        } finally {
            setPrinting(false)
        }
    }

    // Chỉ tải file về máy, không gọi API in -> không tăng số lần in, không lưu thông tin người nhận.
    const _onExportCsv = () => {
        if (!handover) return
        downloadFileFromData(buildSlipCsv(handover), { filename: `phieu-xuat-kho_${handover.code}.csv` })
    }

    const _onBack = () => history.push(HISTORY_PATH)

    return (
        <div className='SewingHandoverPrintContainer'>
            <SewingHandoverPrintPage
                loading={loading}
                printing={printing}
                handover={handover}
                printInfo={printInfo}
                onChangePrintInfo={_onChangePrintInfo}
                onPrint={_onPrint}
                onExportCsv={_onExportCsv}
                onBack={_onBack}
            />
        </div>
    )
}

export default SewingHandoverPrintContainer
